/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { FillingStationIssueModel } from './fillingstationissue';
import { FillingStationIssue } from './fsi';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class FillingStationIssueService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allData(data): Promise<FillingStationIssueModel[]> {
        return this.httpmanagerService.HttpPost('sfillingstationissue/alldata', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    UpdateFillingStationIssue(id, data): Promise<FillingStationIssue> {
        return this.httpmanagerService.HttpPut('sfillingstationissue', JSON.stringify(data), id).then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/fillingstationissue/fillingstationissue.service.ts